/**
 * Vehicle insurance status values
 */
export enum VehicleInsuranceStatusEnum {
	/**
	 * Vehicle insurance is pending
	 */
	PENDING = 'pending',
	/**
	 * Vehicle insurance is active
	 */
	ACTIVE = 'active',
	/**
	 * Vehicle insurance is expired
	 */
	EXPIRED = 'expired',
}
